<template>
  <ChangeBlacklistStateModal :historique-blacklist="data" v-model:visible="showDialog" />
    <div class="treatment-button card-header cursor-pointer">
        <Button :label="props.data.state ? 'Modifier' : 'Traiter'" severity="info" @click="showDialog = true"/>
    </div>
  <div class="custom-card">
    <div class="p-9">
      <div class="grid grid-cols-2 gap-y-2">
        <!-- lastname -->
        <div class="p-2 uppercase bg-gray-100">Nom</div>
        <div class="p-2">{{ props.data.user.lastname }}</div>
        <!-- lastname -->

        <!-- firstname -->
        <div class="p-2 uppercase bg-gray-100">Prénom</div>
        <div class="p-2">{{ props.data.user.firstname }}</div>
        <!-- firstname -->

        <!-- email -->
        <div class="p-2 uppercase bg-gray-100">Email</div>
        <div class="p-2">{{ props.data.user.email }}</div>
        <!-- email -->

        <!-- roles -->
        <div class="p-2 uppercase bg-gray-100">Roles</div>
        <div class="p-2">
          <Tag v-for="role in filteredRolesData"
               :key="role.role"
               :severity="role.severity"
               :value="role.label"
               class="mx-1"
               rounded />
        </div>
        <!-- roles -->

        <!-- company -->
        <div class="p-2 uppercase bg-gray-100">Société</div>
        <div class="p-2">{{ props.data.user.company.name }}</div>
        <!-- company -->

        <!-- lastLoginAt -->
        <div class="p-2 uppercase bg-gray-100">Dernière connexion</div>
        <div class="p-2">{{ props.data.user.lastLoginAt }}</div>
        <!-- lastLoginAt -->

        <!-- phoneNumber -->
        <div class="p-2 uppercase bg-gray-100">Téléphone</div>
        <div class="p-2">{{ props.data.user.phoneNumber }}</div>
        <!-- phoneNumber -->

        <!-- Profil -->
        <div class="p-2 uppercase bg-gray-100">Profil:</div>
        <Button class="p-2 text-left" icon="pi pi-search" size="small" unstyled="unstyled" @click="redirectToLegacyUserProfil" />
        <!-- Profil -->
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {defineProps, PropType, computed, ref, onMounted} from "vue";
import {UserBlacklistHistorique} from "@/models/blacklisting/UserBlacklistHistorique";
import Tag from "primevue/tag";
import Button from "primevue/button";
import ChangeBlacklistStateModal from "@/components/modal/blacklisting/ChangeBlacklistStateModal.vue";

const showDialog = ref(false);
const props = defineProps({
  data: {
    type: Object as PropType<UserBlacklistHistorique>,
    required: true,
  }
});

const rolesData = [
  { role: 'ROLE_ADMIN', severity: 'warning', label: 'Administrateur' },
  { role: 'ROLE_MANAGER', severity: 'danger', label: 'Manager' },
  { role: 'ROLE_CUSTOMER', severity: 'info', label: 'Utilisateur' },
  { role: 'ROLE_DEMO', severity: 'success', label: 'Demo' },
  { role: 'ROLE_SUPPLIER', severity: 'contrast', label: 'Fournisseur' },
];
const filteredRolesData = computed(() =>
    rolesData.filter(role => props.data.user.roles.includes(role.role))
);
const appLegacyUrl = ref<string|undefined>('');

onMounted(async () => {
    appLegacyUrl.value = process.env.VUE_APP_LEGACY_URL;
});

const redirectToLegacyUserProfil = () => {
    window.location.href = `${appLegacyUrl.value}admin/user/${props.data.user.uuid}/detail`;
};
</script>

<style scoped lang="scss">
.p-tag {
  font-weight: 400;
}
.custom-card {
    background-color: #e0e0e8;
    border-radius: 4%;
    color: #000;
    width: 60vh;
}
.treatment-button {
    right: 17px;
    position: relative;
    text-align: right;
    top: -25px;
}

::v-deep(.p-button .p-button-label) {
  font-weight: 400 !important;
}
</style>